import { Fragment, useEffect, useState } from "react";
import { useAuth } from "../../../../Context/AuthContext";
import { ImageWithDefault } from "../../../../Layout/Common/imageWithDefault";
import { Link } from "react-router-dom";
import { base64Encode } from "../../../../Layout/Common/common";
import { ViewPdfButton } from "./viewPdfButton";
import { ViewEbookButton } from "./viewEbookButton";
import { BrowseOnlineButton } from "./browseOnlineButton";

export const GridViewItem = ({ row, viewBox }) => {
  const { isAuthenticated } = useAuth();
  const [item, setItem] = useState(null);
  useEffect(() => {
    setItem(row);
  }, [row]);

  return (
    <Fragment>
      {item && (
        <div key={item.categoryId} className="col-6 col-md-4 col-lg-3 mb-4">
          <div className="card catalogue-card newflyer-card">
            <Link className="catalogue-img">
              <ImageWithDefault
                src={"https://cdn.wes.com.au/prodimages" + item.imageFile}
                alt={item.categoryName}
                classList="w-100"
              />
            </Link>
            <div className="card-body">
              <h5 className="card-title">
                <Link to={item.URL_PATH}>
                  {String(item.categoryName || "").length > 52
                    ? `${String(item.categoryName).slice(0, 52)}...`
                    : item.categoryName}
                </Link>
              </h5>
              <p className="card-text">
                <span className="newFlyer-date">{item.modifiedDate}</span>
                <span>{item.categoryId}</span>
              </p>
              <div className="wesFlyer-btns">
                <div>
                  <ViewPdfButton item={item} />
                  <ViewEbookButton item={item} />
                </div>
                <BrowseOnlineButton item={item} />
              </div>
            </div>
          </div>
        </div>
      )}
    </Fragment>
  );
};
